// Copyright (c) 2016 Deere & Company

import { FormattedMessage } from 'react-intl';
import React from 'react';
import { createErrorMessage } from '../action-creators/alert-messages';
import { getStore } from '../../configmodules/store-reducer-config/store';

export const errorAlertBar = (errorObject) => {

    const { dispatch } = getStore();
    if (errorObject.message) {

        errorObject.isTranslated ?
            dispatch(createErrorMessage(errorObject.message)) :
            dispatch(createErrorMessage(<FormattedMessage id={errorObject.message} />));

    } else {

        dispatch(createErrorMessage(<FormattedMessage id="UNABLE_TO_CONTACT_THE_SERVER" />));

    }

};
